import React, { useState, useEffect, memo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"
import Sidebar from "@/components/project-dashboard/Sidebar"
import Box from "@material-ui/core/Box"
import ProjectDashboardContent from "@/components/project-dashboard/ProjectDashboardContent"
import WelcomeDialog from "@/components/project-dashboard/WelcomeDialog"
import ViewDepartment from "@/components/project-dashboard/view-department/ViewDepartment"
import ViewDesignation from "@/components/project-dashboard/view-designation/ViewDesignation"
import ProjectDialogContainer from "@/components/project-dashboard/ProjectDialogContainer"
import ProjectRedeploymentDialogContainer from "@/components/project-dashboard/ProjectRedeploymentDialogContainer"
import { userFirstVisitProjectDashboard } from "@/redux/actions/userAction"
import { getProductsStatusList } from "@/redux/actions/productAction"
import { getCompanyByCompanyIdAction } from "@/redux/actions/companyAction"
import Button from "@material-ui/core/Button"
import useTopRoleIsAccountHolder from "@/hooks/useTopRoleIsAccountHolder"
import { Routes, Route, useNavigate, Navigate } from "react-router-dom"
import { urlPath } from "@/utils"
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
    main: {
        position: "relative",
    },
    projectDashboard: {
        flexBasis: "auto",
        flexGrow: 1,
        position: "relative",
    },
    // aside: {
    //     flexGrow: 0,
    //     width: "250px",
    //     justifyContent: "center",
    //     borderRightColor: theme.palette.sparcaLightGrey.main,
    //     borderRightWidth: "1px",
    //     borderRightStyle: "solid",
    //     flexBasis: "250px",
    //     boxSizing: "border-box",
    //     // backgroundColor: theme.palette.sparcaLightGrey.main,
    //     [theme.breakpoints.down("sm")]: {
    //         display: "none",
    //     },
    // },
    aside: {
        zIndex: 0,
    },

    goBackWrapper: {
        position: "absolute",
        right: "20px",
        top: "16px",
        cursor: "pointer",
        zIndex: 1,
    },
    goBackButtonWrapper: {
        display: "none",
        [theme.breakpoints.up("md")]: {
            display: "block",
        },
    },
}))

const ProjectDashboard = () => {
    const [drawerOpen, setDrawerOpen] = React.useState(true)
    const classes = useStyles()
    const navigate = useNavigate()
    const [firstVisitModalOpen, setFirstVisitModalOpen] = useState(false)

    const userData = useSelector((state) => state.userReducer)
    const dispatch = useDispatch()
    const topRoleIsAccountHolder = useTopRoleIsAccountHolder(userData)
    const { user } = userData // signed up user

    // render user ordered product
    useEffect(() => {
        const requestProductsStatusList = () => {
            dispatch(getProductsStatusList(user.companyId))
        }
        requestProductsStatusList()
    }, [user.userId])

    // render user company detail
    useEffect(() => {
        const getCompanyByCompanyIdFunc = () => {
            dispatch(getCompanyByCompanyIdAction(user.companyId))
        }
        getCompanyByCompanyIdFunc()
    }, [user.companyId])

    // detect if user is the first time to visit this page(with project manager role and project sponsor role), if first time, open welcome message.
    // add date_project_dashboard_first_visit on user table(old is Date_First_visit on company table)
    useEffect(() => {
        const detectLoading = () => {
            if (user && !user.dateProjectDashboardFirstVisit) {
                // display welcome modal
                setFirstVisitModalOpen(true)
            }
        }
        detectLoading()
    }, [user])

    const handleClose = () => {
        setFirstVisitModalOpen(false)
        // add first visit date to database
        dispatch(userFirstVisitProjectDashboard(user.userId))
    }

    const handleOpen = () => {
        setFirstVisitModalOpen(true)
    }

    const projectDashboardOutput = () => {
        return (
            <>
                <Routes>
                    <Route path="/view-department" element={<ViewDepartment companyId={user.companyId} />} />
                    <Route path="/view-designation" element={<ViewDesignation companyId={user.companyId} />} />
                    <Route path="/" element={<ProjectDashboardContent drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />} />
                    <Route path="/*" element={<Navigate replace to={urlPath("dashboard", user.userId)} />} />
                </Routes>
            </>
        )
    }

    return (
        <>
            <WelcomeDialog firstVisitModalOpen={firstVisitModalOpen} handleOpen={handleOpen} handleClose={handleClose} />
            <ProjectDialogContainer />
            <ProjectRedeploymentDialogContainer />
            <Box component="div" display="flex" className={classes.projectDashboard}>
                <Box component="aside" className={classes.aside}>
                    <Sidebar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                </Box>
                {/* {topRoleIsAccountHolder && (
                    <Box className={classes.goBackButtonWrapper}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.goBackWrapper}
                            onClick={() => {
                                navigate(urlPath("account-holder-main", user.userId))
                            }}
                        >
                            Home page
                        </Button>
                    </Box>
                )} */}
                <Box component="div" className={classes.main} display="flex" flexDirection="column" width={1}>
                    {projectDashboardOutput()}
                </Box>
            </Box>
        </>
    )
}

export default ProjectDashboard

/*
Account holder, project manager and project sponsor can access this page, but project sponsor cannot create project
*/
